import type { ChannelContextValue } from 'src/types/checkout';

import { createContext } from 'react';

// ----------------------------------------------------------------------

export const ChannelContext = createContext<ChannelContextValue | undefined>(undefined);
